import React from 'react';
import { EntityStatus, EntityTypes } from '@guryou/core';
import { dealTheme } from '@guryou/html-theme';
import { calculateContrastText } from '@guryou/utils';
import { CourseIcon, DirectionsWalkIcon, EventIcon, ProfileIcon, ServiceIcon } from '../icons';

// const lightenColor = (hex, percent) => {
//   const r = parseInt(hex.substring(1, 3), 16);
//   const g = parseInt(hex.substring(3, 5), 16);
//   const b = parseInt(hex.substring(5, 7), 16);

//   const hsl = rgbToHsl(r, g, b);

//   hsl[2] = Math.min(1, hsl[2] + percent / 100);

//   return hslToHex(hsl[0], hsl[1], hsl[2]);
// };

// const rgbToHsl = (r, g, b) => {
//   r /= 255;
//   g /= 255;
//   b /= 255;
//   const max = Math.max(r, g, b),
//     min = Math.min(r, g, b);
//   let h = (max + min) / 2;
//   let s = (max + min) / 2;
//   const l = (max + min) / 2;

//   if (max === min) {
//     h = s = 0; // achromatic
//   } else {
//     const d = max - min;
//     s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
//     switch (max) {
//       case r:
//         h = (g - b) / d + (g < b ? 6 : 0);
//         break;
//       case g:
//         h = (b - r) / d + 2;
//         break;
//       case b:
//         h = (r - g) / d + 4;
//         break;
//       default:
//         h = (r - g) / d + 4;
//     }
//     h /= 6;
//   }

//   return [h, s, l];
// };

// const hslToHex = (h, s, l) => {
//   const hueToRgb = (p, q, t) => {
//     if (t < 0) {
//       t += 1;
//     }
//     if (t > 1) {
//       t -= 1;
//     }
//     if (t < 1 / 6) {
//       return p + (q - p) * 6 * t;
//     }
//     if (t < 1 / 2) {
//       return q;
//     }
//     if (t < 2 / 3) {
//       return p + (q - p) * (2 / 3 - t) * 6;
//     }
//     return p;
//   };

//   const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
//   const p = 2 * l - q;
//   const r = Math.round(hueToRgb(p, q, h + 1 / 3) * 255);
//   const g = Math.round(hueToRgb(p, q, h) * 255);
//   const b = Math.round(hueToRgb(p, q, h - 1 / 3) * 255);

//   return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
// };

const calculatePreparationPercentage = (duration, preparationTime) => {
  if (duration <= 0) {
    return [100, 0];
  }
  const preparationPercentage = preparationTime / duration * 100;
  const durationPercentage = 100 - preparationPercentage;
  return [durationPercentage, preparationPercentage];
};
export const getColorProps = _ref => {
  let {
    color,
    type,
    status,
    duration,
    preparationTime,
    entityType
  } = _ref;
  let result = {};
  if (entityType === 'pause') {
    return {
      border: '2px solid #dc2626',
      backgroundColor: '#ffffff',
      color: '#000000'
    };
  }
  if (entityType === 'holiday') {
    return {
      border: '2px solid #000000',
      backgroundColor: '#ffffff',
      color: '#000000'
    };
  }
  const [pp, dp] = calculatePreparationPercentage(duration, preparationTime);
  if (color) {
    result = {
      // backgroundColor: color,
      background: "linear-gradient(to bottom, ".concat(color, " ").concat(pp, "%, #D3D3D3 ").concat(dp, "%)"),
      color: calculateContrastText(color)
    };
  } else {
    const paletteKey = type === EntityTypes.reservation ? 'primary' : type === EntityTypes.subscription ? 'secondary' : 'info';
    result = {
      backgroundColor: dealTheme.palette[paletteKey].main,
      color: dealTheme.palette[paletteKey].contrastText
    };
  }
  if (status === EntityStatus.canceled) {
    result.opacity = 0.7;
  }
  return result;
};
export const getEventIcon = function (_ref2) {
  let {
    entityType
  } = _ref2;
  let fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  if (entityType === EntityTypes.service) {
    return /*#__PURE__*/React.createElement(ServiceIcon, {
      fontSize: fontSize
    });
  }
  if (entityType === EntityTypes.course) {
    return /*#__PURE__*/React.createElement(CourseIcon, {
      fontSize: fontSize
    });
  }
  return /*#__PURE__*/React.createElement(EventIcon, {
    fontSize: fontSize
  });
};
export const getCustomerIcon = function (user) {
  let fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  if (user) {
    return /*#__PURE__*/React.createElement(ProfileIcon, {
      fontSize: fontSize
    });
  }
  return /*#__PURE__*/React.createElement(DirectionsWalkIcon, {
    fontSize: fontSize
  });
};
export const getNamePreset = function () {
  var _event$user;
  let namePreset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'username';
  let event = arguments.length > 1 ? arguments[1] : undefined;
  const userType = event !== null && event !== void 0 && event.user && event !== null && event !== void 0 && (_event$user = event.user) !== null && _event$user !== void 0 && _event$user.id ? event.user : event.visitatore;
  if (userType && userType !== null && userType !== void 0 && userType.id) {
    if (namePreset === 'username') {
      return (userType === null || userType === void 0 ? void 0 : userType.name) || (event === null || event === void 0 ? void 0 : event.displayName);
    }
    if (namePreset === 'firstnameLastname') {
      const fullName = "".concat(userType.firstname || '', " ").concat(userType.lastname || '');
      if (fullName.trim() !== '') {
        return fullName;
      }
      return (userType === null || userType === void 0 ? void 0 : userType.name) || (event === null || event === void 0 ? void 0 : event.displayName);
    }
    if (namePreset === 'lastnameFirstname') {
      const fullName = "".concat((userType === null || userType === void 0 ? void 0 : userType.lastname) || '', " ").concat((userType === null || userType === void 0 ? void 0 : userType.firstname) || '');
      if (fullName.trim() !== '') {
        return fullName;
      }
      return (userType === null || userType === void 0 ? void 0 : userType.name) || (event === null || event === void 0 ? void 0 : event.displayName);
    }
    return (userType === null || userType === void 0 ? void 0 : userType.name) || (event === null || event === void 0 ? void 0 : event.displayName) || (event === null || event === void 0 ? void 0 : event.email) || 'NO NAME';
  }
  return (event === null || event === void 0 ? void 0 : event.displayName) || (event === null || event === void 0 ? void 0 : event.email) || 'NO NAME';
};